import {
  CreditCardsThunks,
  SET_CREDIT_CARDS,
  SET_SAVE_CREDIT_CARD,
  SET_SELECTED_CREDIT_CARD,
  SetCreditCardsActionType,
  SetSelectedCardActionType,
  SetSaveCreditCardActionType,
} from './creditCardsActionTypes';
import { CreditCardType } from './creditCardsTypes';
import CreditsApi from '../../API/credits/Credits.api';
import { startLoaderThunk, stopLoaderThunk } from '../modal/modalActions';

export function setSaveCreditCardAction(
  value: boolean
): SetSaveCreditCardActionType {
  return {
    type: SET_SAVE_CREDIT_CARD,
    payload: value,
  };
}

export function setCreditCardsAction(
  creditCards: CreditCardType[]
): SetCreditCardsActionType {
  return {
    type: SET_CREDIT_CARDS,
    payload: creditCards,
  };
}

export function setSelectedCreditCardAction(
  creditCard: CreditCardType
): SetSelectedCardActionType {
  return {
    type: SET_SELECTED_CREDIT_CARD,
    payload: creditCard,
  };
}

export function FetchCreditCardsThunk(): CreditCardsThunks<Promise<void>> {
  return async (dispatch, getState) => {
    dispatch(startLoaderThunk()).finally();
    CreditsApi.getCreditCards()
      .then((response) => {
        dispatch(setCreditCardsAction(response.data));
      })
      .finally(() => dispatch(stopLoaderThunk()));
  };
}

export function RemoveCreditCardThunk(
  id: number
): CreditCardsThunks<Promise<void>> {
  return async (dispatch) => {
    dispatch(startLoaderThunk()).finally();
    CreditsApi.removeCreditCard(id)
      .then(() => {
        dispatch(FetchCreditCardsThunk());
      })
      .finally(() => dispatch(stopLoaderThunk()));
  };
}
